import styled from 'styled-components';

export const StyledKeybind = styled.kbd`
  background-color: ${(p) => p.theme.alias.shadow};
`;
